import { defineStore } from "pinia";

export const useRouteStore = defineStore("routeStore", {
  state: () => ({
    previousRoute: null,
  }),
  actions: {
    setPreviousRoute(route) {
      this.previousRoute = route;
    },
  },
  persist: true, // <- If you're using pinia-plugin-persistedstate
});

export const useApplicationStore = defineStore('applicationStore', {
  state: () => ({
    current_selected: null,
  }),
});
